<template>
    <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50" @click.self="closeModal">
        <div class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8 modal-overscroll">
            <div class="w-[100vw] px-[20px] m-auto">
                <!-- actual modal -->
                <div class="max-w-[1000px] w-full mx-auto box-effect rounded-[10px] bg-white overflow-hidden ">
                    <header class="w-full py-3 pl-5 pr-2.5 bg-primary">
                        <div class="w-full flex justify-between items-center">
                            <span class="text-sm text-white">{{ data.name }} ที่ปิดทำการ</span>
                            <CloseIcon @click="closeModal"
                                class="w-6 h-6 text-primary bg-white rounded-full cursor-pointer" />
                        </div>
                    </header>
                    <section class="p-5 pt-3 overflow-auto max-h-[80vh]">
                        <SearchBox v-model="filter.search" @update:modelValue="
                            () => {
                                (filter.page = ''), debouncedFetch();
                            }
                        " :placeholder="'ค้นหา ชื่อ' + data.name" />
                        <div v-if="damagedUnitInfos.length == 0" class="my-2.5 text-center py-[40px] px-[20px]">
                            <div class="flex flex-col gap-[9px]  items-center justify-center">
                                <DisasterIcon2 class="w-[62px] h-[62px] text-[#B7B2B5]" />
                                <span class="PC_Body1-R text-[#7C7379]">ขณะนี้ยังไม่มีข้อมูล</span>
                            </div>


                        </div>
                        <div v-else id="infos" class="w-full my-2.5 min-h-[189px]">
                            <ul class="w-full my-2.5 ">
                                <li class=" w-full  first:rounded-t-[10px] last:rounded-b-[10px] first:border-b-0 last:border-b-1 border border-b-0 border-[#DFDCDD] "
                                    v-for="(item, i) of damagedUnitInfos">
                                    <!-- แถวหัวข้อ -->
                                    <div class="w-full flex items-center justify-between gap-3 p-[8px] text-left flex-wrap"
                                        :aria-expanded="open[i] ? 'true' : 'false'" @click="open[i] = !open[i]">
                                        <span class="BodyS">{{ item.name }}</span>
                                        <div class="flex gap-[10px]" :class="{'w-full sm:w-fit justify-end' : open[i] && !readOnlyRef}">
                                            <button v-if="open[i] && !readOnlyRef" @click.stop="removeDamagedUnits(item)"
                                                class="flex items-center justify-center rounded-[6px] border border-[#B7B2B5] w-[30px] h-[30px]">
                                                <TrashcanIcon class="w-[16px] h-[16px] text-primary" />
                                            </button>
                                            <button v-if="open[i] && !readOnlyRef" @click.stop="updateDamagedUnits(item)"
                                                class="flex items-center justify-center rounded-[6px] border border-[#B7B2B5] w-[30px] h-[30px]">
                                                <EditIcon class="w-[16px] h-[16px] text-primary" />
                                            </button>
                                            <!-- ไอคอนลูกศร -->
                                            <button
                                                class="flex items-center justify-center rounded-[6px] border border-[#B7B2B5] w-[30px] h-[30px]">
                                                <svg class="shrink-0 transition-rotate duration-300"
                                                    :class="open[i] ? 'rotate-180' : 'rotate-0'" width="20" height="20"
                                                    viewBox="0 0 24 24" fill="none">
                                                    <path d="M6 9l6 6 6-6" stroke="#9b237b" stroke-width="3"
                                                        stroke-linecap="round" stroke-linejoin="round" text-primary />
                                                </svg>
                                            </button>
                                        </div>

                                    </div>

                                    <!-- เนื้อหาที่พับได้ -->
                                    <div class="v-collapse" :data-open="open[i] ? 'true' : 'false'">
                                        <div class="v-collapse__inner">
                                            <div class="p-[10px] bg-[#FBEFF8] "
                                                :class="i === damagedUnitInfos.length - 1 ? 'rounded-b-[10px]' : ''">
                                                <div class="flex items-center justify-between mb-[20px] sm:mb-[10px] flex-wrap sm:flex-nowrap gap-[10px]">
                                                 <div class="flex flex-col sm:flex-row sm:gap-[4px]">
    <div class="flex items-start">
        <span class="PC_Body2-R text-[#9B237B] sm:w-[140px]">ที่ตั้ง</span>
    </div>

    <div class="flex gap-[4px]">
        <span class="PC_Body2-R text-[#1F1D1F]">:</span>
        <span class="PC_Body2-R text-[#1F1D1F]">
            {{ compactAddress(item) }}
        </span>
    </div>
</div>
                                                    <div class="flex gap-2">
                                                        <button :disabled="item.gis_map ? false : true"
                                                            class="w-[80px] h-[42px] bg-[#FFFFFF] text-[#1F1D1F] border border-[#B7B2B5] rounded-[6px]"
                                                            @click="gotoGis(item)">
                                                            <span class="ButtonS">
                                                                GIS Map
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="flex flex-col sm:flex-row sm:gap-[4px]">
    <div class="flex items-start">
        <span class="PC_Body2-R text-[#9B237B] sm:w-[140px]">หมายเลขติดต่อฉุกเฉิน</span>
    </div>

    <div class="flex gap-[4px]">
        <span class="PC_Body2-R text-[#1F1D1F]">:</span>
        <span class="PC_Body2-R text-[#1F1D1F]">
            {{ item.phone || '-' }}
        </span>
    </div>
</div>

                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <PaginationComponent :items="paginationInfo" @selectedPage="handlePage" />
                    </section>
                </div>
            </div>
        </div>
        <StatusModal ref="statusModalRef" @submit="cfDeleteModal" />
    </div>
</template>
<script setup>
import { ref, computed, onMounted, watch } from "vue";
import axios from "axios";
import { compact, debounce } from "lodash";
import "@/assets/css/collapse.scss";
const emit = defineEmits(["edit", "closeFetch"]);
const modalIsOpened = ref(false);
const paginationInfo = ref({});
const statusModalRef = ref('');
const errors = ref({});

const filter = ref({
    paginate: 10,
    page: "",
    search: "",
});
const open = ref([]);
const countDeleteData = ref(0);

// const damagedUnitInfos = ref([]);
const damagedUnitInfos = ref([]);
const damagedUnitID = ref(null)
const data = ref({});
const readOnlyRef = ref(false)

const handlePage = (page, perpage) => {
  filter.value.page = page;
  filter.value.paginate = perpage;
  getData();
};
const getData = () => {
    axios
        .get("/damaged-utilities/" + data.value.id, { params: filter.value })
        .then((res) => {
            if (res.data.code == 200) {
                console.log("damaged-utilities ", res.data);
                paginationInfo.value = res.data.data;
                damagedUnitInfos.value = res.data.data.data;
            }

        })
        .catch((err) => {
            console.log(err);

        });
};
const openModal = (damagedUnit, oldData, newData, readOnly) => {
    // console.log('start : damagedUnit.id :: ', damagedUnit.id);
    readOnlyRef.value = false
    countDeleteData.value = 0
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    console.log("newData :: ", newData);
    if (oldData) {
        if (newData) {
            console.log('damagedUnit.id :: ', data.value.id);
            console.log('newData.data.type :: ', newData.data.type);

            if (data.value.id != newData.data.type) {
                getData();
            } else {
                let indexOfNewData = damagedUnitInfos.value.findIndex(item => item.id == newData.data.id)
                console.log('indexOfNewData ::: dulipicate :: ', indexOfNewData);
                if (indexOfNewData != -1) {
                    damagedUnitInfos.value[indexOfNewData] = newData.data
                }
            }
        }
    } else {
        if (readOnly) {
            readOnlyRef.value = true
        }
        filter.value.search = "";

        data.value = damagedUnit;
        axios
            .get("/damaged-utilities/" + damagedUnit.id, { params: filter.value })
            .then((res) => {
                if (res.data.code == 200) {
                    console.log("damaged-utilities ", res.data);
                    paginationInfo.value = res.data.data;
                    damagedUnitInfos.value = res.data.data.data;
                }

            })
            .catch((err) => {
                console.log(err);
            });
    }

    modalIsOpened.value = true;
};
const showModal = () => {
    modalIsOpened.value = true;
}
const hideModal = () => {
    modalIsOpened.value = false;
}
const compactAddress = (value) => {
    return `${value.address} ต.${value.subdistrict_name_th} อ.${value.district_name_th} จ.${value.province_name_th} ${value.postal_code}`
}
const gotoGis = (value) => {
    window.open(value.gis_map, '_blank');
}
const removeDamagedUnits = (item) => {
    damagedUnitID.value = item
    statusModalRef.value.openModal("warning", {
        header: "คำเตือน !",
        subHeader: "ข้อมูลจะถูกล้างออกทั้งหมด ไม่สามารถกู้คืนได้ ท่านต้องการลบข้อมูลหรือไม่",
        closeButtonText: "ปิดหน้าต่าง",
        submitButtonText: 'ลบ'
    }, item);
}
const cfDeleteModal = () => {
    console.log(" :: cfDeleteModal :: ", damagedUnitID.value);
    axios.delete('/damaged-utility/' + damagedUnitID.value.id).then((res) => {
        if (res.data.code == 200) {
            countDeleteData.value += 1
            statusModalRef.value.openModal("success", {
                header: "ดำเนินการสำเร็จ !",
                subHeader: res.data.message,
                closeButtonText: "ปิดหน้าต่าง",
                timeout: 5000
            });
            getData();
        } else {
            statusModalRef.value.openModal("error", {
                header: "ดำเนินการไม่สำเร็จ !",
                subHeader: res.data.message,
                closeButtonText: "ปิดหน้าต่าง",
            });
        }
    }).catch((err) => {
        console.log(err);
        statusModalRef.value.openModal("error", {
            header: "ดำเนินการไม่สำเร็จ !",
            subHeader: res.data.message,
            closeButtonText: "ปิดหน้าต่าง",
        });
    })
};
const updateDamagedUnits = (item) => {
    emit('edit', item)
    hideModal()
}
const closeModal = () => {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
    filter.value.search = "";
    damagedUnitInfos.value = []
    modalIsOpened.value = false;
    if (countDeleteData.value > 0) {
        emit('closeFetch')
    }
};

watch(damagedUnitInfos, (arr) => {
    open.value = Array(arr.length).fill(false);
}, { immediate: true });

const debouncedFetch = debounce(getData, 300);
defineExpose({
    openModal,
    closeModal,
});
</script>

<style lang="scss" scoped>
.BodyS {
  // color: #7c7379;

  /* Body/s */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  letter-spacing: 0.1px;
}
.ButtonS {
  color: #1f1d1f;
  text-align: center;

  /* Button/s */
  font-family: Kanit;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 153.846% */
  letter-spacing: 0.1px;
}
</style>